module.exports = __webpack_public_path__ + "static/TakeshiAndHiroshi1-26911dc48bed77ee3ee7408d85fa86f4.png";